import '../../shared-styles.scss';
import React, { useEffect, useState } from "react";
import brandLogo from "../../assets/parkingHeroLogo.svg";
import appleLogo from "../../assets/icons/apple-logo.png"
import facebookLogo from "../../assets/icons/facebook-logo.png"
import googleLogo from "../../assets/icons/google-logo.png"
import { DialogBox } from "../../components/dialogBox";
import { useFormik } from 'formik';
import { registerSchema, registerValidations } from './validators';
import { AuthService } from "../../services/auth.service";
import "./styles.scss";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextFieldLogin from "../../components/TextFieldLogin";
import { STATUS } from "../../common/constant";
import Loader from "../../components/Loader";
import { MobileField } from "../../components/MobileField";
import { ErrorDialog } from "../../components/errorDialog";
import { Link, useLocation } from "react-router-dom";

export const SignUpPage: React.FC = () => {

    const data = `Every kid has his own vision of doing something unique in life. Sometimes parents also dream of 
    their kids to be at high professions like doctors, engineers, IAS or PCS officers, or any other high-level 
    professions. All such goals of kids or parents can be achieved by education only.In this competitive era, 
    everyone must have a good education and sound knowledge to achieve goals of life. Education does not only offer 
    a good job but also enhances the ability to understand life from a new perspective. Decent education produces 
    many paths to move ahead in life. It makes us intellectually, and ethically, powerful by improving our expertise 
    level, technical abilities, and excellent job.Also, some children are interested in other areas such as sports, 
    dance, music, and many more, they can do their additional education with their related degree, experience, 
    talents, and spirit. In India, there are various boards of education available like state wise boards 
    (Gujarat board, UP board, etc.), ICSE Board, CBSE Board, etc. And education is available in various languages 
    like a kid can study in their mother tongue or in Hindi medium or in English medium, it is the choice of parents 
    or kid to select a board or a language. This is the age where Education is very important and with the help of 
    it, anyone can change his/her life in a better way.`

    const [show, setShow] = useState<boolean>(false);
    const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
    const [dialogueStatus, setDialogueStatus] = useState<string>("");
    const [dialogueErrorMsg, setDialogueErrorMsg] = useState<string>("");
    const [loader, setLoader] = useState<boolean>(false);
    const [errorDialog, setErrorDialog] = useState<boolean>(false)
    const message = "Kindly Accept terms of use and Privacy policy"
    const location: any = useLocation();
    const URL = location?.state?.qrUserId;

    const registerSubmit = async (values: any): Promise<void> => {
        const authenticationService = new AuthService();
        if (!isTermsAccepted) {
            setDialogueStatus("error")
            setDialogueErrorMsg(message)
            setShow(true)
            return
        }
        try {
            setLoader(true)
            const registerValues: any = {
                hero_name: values?.heroName,
                phone_number: values?.phone.toString(),
                country_code: values?.countryCode,
                email: values?.email.toLowerCase(),
                zip_code: values?.zipCode.toString(),
                password: values?.password,
                confirm_password: values?.confirmPassword,
                referal_code: values?.referralCode,
                role: values?.role ? values?.role : "USER"
            }
            const registerResponse = await authenticationService.Signup(registerValues);
            setLoader(false)
            if (registerResponse.status === STATUS.SUCCESS) {
                setDialogueStatus("waiting")
                setShow(true)
            } else {
                setDialogueStatus("error")
                setDialogueErrorMsg(registerResponse.message)
                setShow(true)
            }
        }
        catch (error: any) {
            console.log(error)
        }
    }

    const registerFormik = useFormik({ initialValues: registerSchema, validationSchema: registerValidations, onSubmit: registerSubmit });

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="SignUpPage-page" >
            <div className="logo-wrapper">
                <Link to={"/"}><img className="brand-logo" src={brandLogo} alt="" /></Link>
            </div>
            <div>
                <h1 className="SignUpPage-page-heading">Create your account</h1>
            </div>

            <div className="social-login-icons">
                <img src={facebookLogo} alt={"not Found"} />
                <img src={googleLogo} alt={"not Found"} />
                <img src={appleLogo} alt={"not Found"} />

            </div>
            <form onSubmit={registerFormik.handleSubmit} >
                <div className="form-data">
                    <TextFieldLogin
                        label='Hero name'
                        formik={{ ...registerFormik.getFieldProps('heroName') }}
                        error={registerFormik.touched.heroName && registerFormik.errors.heroName}
                        errorText={registerFormik.errors.heroName}
                    />
                    <MobileField
                        label='Phone'
                        formikCode={{ ...registerFormik.getFieldProps('countryCode') }}
                        formikNumber={{ ...registerFormik.getFieldProps('phone') }}
                        error={registerFormik.touched.phone && registerFormik.errors.phone}
                        errorText={registerFormik.errors.phone}
                    />
                    <h4 className="notice-field">Your phone number will remain confidential</h4>
                    <TextFieldLogin
                        label='Email'
                        formik={{ ...registerFormik.getFieldProps('email') }}
                        error={registerFormik.touched.email && registerFormik.errors.email}
                        errorText={registerFormik.errors.email}
                    />
                    <TextFieldLogin
                        label='Zipcode'
                        type={"number"}
                        formik={{ ...registerFormik.getFieldProps('zipCode') }}
                        error={registerFormik.touched.zipCode && registerFormik.errors.zipCode}
                        errorText={registerFormik.errors.zipCode}
                    />
                    <TextFieldLogin
                        label='Password'
                        type={'password'}
                        formik={{ ...registerFormik.getFieldProps('password') }}
                        error={registerFormik.touched.password && registerFormik.errors.password}
                        errorText={registerFormik.errors.password}
                    />
                    <TextFieldLogin
                        type='password'
                        label='Confirm Password'
                        formik={{ ...registerFormik.getFieldProps('confirmPassword') }}
                        error={registerFormik.touched.confirmPassword && registerFormik.errors.confirmPassword}
                        errorText={registerFormik.errors.confirmPassword}
                    />
                    <TextFieldLogin
                        label='Referral Code(Optional)'
                        formik={{ ...registerFormik.getFieldProps('referralCode') }}
                        error={registerFormik.touched.referralCode && registerFormik.errors.referralCode}
                        errorText={registerFormik.errors.referralCode}
                    />
                </div>
                <div className="terms">
                    <h4 className="lable-field">Please read our terms of use: </h4>
                    <div className="text-box">
                        <div className="text">
                            <p>{data}</p>
                        </div>
                        <div className="checkbox">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 26 },
                                            color: "#ffffff",
                                            '&.Mui-checked': { color: "#ffffff" }
                                        }}
                                        onChange={(e) => { setIsTermsAccepted(e.target.checked) }}
                                    />
                                }
                                label="Agree to terms of use"
                                sx={{
                                    fontWeight: 600,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="signup">
                    <button className="btn signup-btn"
                        type="submit">Sign up</button>
                </div>
            </form>
            <div className="end-content">
                <p className="lable-field">Thank you for joining! Please verify by replying to our email & text.</p>
            </div>
            {show && <DialogBox status={dialogueStatus} show={true} setShow={setShow} errorMessage={dialogueErrorMsg} userId={URL} />}
            {errorDialog && <ErrorDialog show={errorDialog} setShow={setErrorDialog} message={message} />}
            {loader && <Loader />}
        </div>
    );
};
